/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeAddOrderStatusRequest, serializeDeleteOrderStatusRequest, serializeOk, type AddOrderStatusRequest, type DeleteOrderStatusRequest, type ErrorResponse, type Ok } from '../../../models/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-statuses
 */
export interface OrderStatusesRequestBuilder extends BaseRequestBuilder<OrderStatusesRequestBuilder> {
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * Removes an order status from the organization's list. Orders already carrying the value keep it — this only curates the picker and filter options. Removing the first status promotes the next one to be what new orders are submitted with.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(body: DeleteOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Adds an order status (e.g. Created, Processing, Shipped, Cancelled) to the organization's list, which the Orders grid filters by and checkout stamps onto new orders. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored. The first status in the list is the one new orders are submitted with.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     post(body: AddOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Removes an order status from the organization's list. Orders already carrying the value keep it — this only curates the picker and filter options. Removing the first status promotes the next one to be what new orders are submitted with.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds an order status (e.g. Created, Processing, Shipped, Cancelled) to the organization's list, which the Orders grid filters by and checkout stamps onto new orders. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored. The first status in the list is the one new orders are submitted with.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderStatusesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-statuses";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderStatusesRequestBuilderNavigationMetadata: Record<Exclude<keyof OrderStatusesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderStatusesRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: OrderStatusesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteOrderStatusRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: OrderStatusesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddOrderStatusRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
